import quickRange, * as fromQuickRange from './quickRange';
import fromDate, * as fromFromDate from './fromDate';
import toDate, * as fromToDate from './toDate';
import { combineReducers } from 'redux';
import { CHART_TYPE } from '../../../../../utils/constants';

export default combineReducers({
  quickRange,
  fromDate,
  toDate
});

export const getQuickRange = state => fromQuickRange.getQuickRange(state.quickRange, CHART_TYPE.MAIN);
export const getFromDate = state => fromFromDate.getFromDate(state.fromDate);
export const getToDate = state => fromToDate.getToDate(state.toDate);